<app-top-section></app-top-section>
<section>
  <div class="flex flex-row flex-wrap w-full h-full">
    <div class="w-full sm:w-1/2">
      <button class="secondary-result-btn" data-testid="extraPt" (click)="kickoffSelected()">
        {{ 'components.menuActions.kickoff' | transloco }}
      </button>
    </div>
    <div class="w-full sm:w-1/2">
      <button class="secondary-result-btn" data-testid="conversion2pts" (click)="startOn35Selected()">
        {{ 'components.menuActions.ballOn35' | transloco }}
      </button>
    </div>
  </div>
</section>
